import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

export const Equalizer = ({
  width = 16,
  height = 16,
  fillColor = '#000000',
  style
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fillColor}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 6V10" stroke="black" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M8 3.33333V12.6667"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 6.66667V9.33334"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};